import { createSlice } from "@reduxjs/toolkit";
import { fetchPurchaseOrder, fetchPOAnalytics } from "./thunk";

interface purchaseOrderState {
  POList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  analyticsData: any;
  loadingAnalytics: boolean;
  // selectedRFQ: any;
}

const initialState: purchaseOrderState = {
  POList: [],
  rowCount: 0,
  loading: false,
  error: null,
  analyticsData: null,
  loadingAnalytics: false,
  // selectedRFQ: null,
};

const purchaseOrderSlice = createSlice({
  name: "purchaseOrder",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPurchaseOrder.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPurchaseOrder.fulfilled, (state, action) => {
        state.loading = false;
        state.POList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchPurchaseOrder.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Purchase Order";
      })
      .addCase(fetchPOAnalytics.pending, (state) => {
        state.loadingAnalytics = true;
      })
      .addCase(fetchPOAnalytics.fulfilled, (state, action) => {
        state.loadingAnalytics = false;
        state.analyticsData = action.payload;
      })
      .addCase(fetchPOAnalytics.rejected, (state) => {
        state.loadingAnalytics = false;
      });
  },
});

export default purchaseOrderSlice.reducer;
